import repository from './repository';
import axios from "axios";

const API = process.env.VUE_APP_API_URL;

let roleRepository = repository('/role');

roleRepository.getAllRoles = () => {
    return axios.get(API + '/role/get_all_roles');
};

export default roleRepository;
